import type { MutationOptions } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import {
  handleResponseSuccess,
  handleResponseThrowError,
} from '@/_utils/services';
import { apiClient } from '@/_config/lib/axios/api-client';

type PutChangePlaceLinkedParams = {
  placeId: string;
  isLinked: boolean;
};

const putChangePlaceLinked = async ({
  placeId,
  isLinked,
}: PutChangePlaceLinkedParams) =>
  apiClient
    .put(`/estabelecimentos/${placeId}/change-linked-management`, {
      isLinked,
    })
    .then(response =>
      handleResponseSuccess(
        response,
        `Gestão própria ${isLinked ? 'ativada' : 'desativada'} com sucesso!`,
      )(),
    )
    .catch(
      handleResponseThrowError(
        'Não foi possível alterar o status da gestão própria.',
      ),
    );

export const usePutChangePlaceLinked = ({
  onSuccess,
  ...options
}: MutationOptions<unknown, unknown, PutChangePlaceLinkedParams> = {}) => {
  return useMutation({
    mutationFn: putChangePlaceLinked,
    onSuccess: (...args) => {
      onSuccess?.(...args);
    },
    ...options,
  });
};
